export function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }

    return array;
}

export function reorderArray(array, start_index, end_index) {
    let result    = Array.from(array);
    let [removed] = result.splice(start_index, 1);

    result.splice(end_index, 0, removed);
    return result;
}

export function swapArray(sourceArray, destArray, source, destination) {
    const result    = {};
    let sourceClone = Array.from(sourceArray);
    let destClone   = Array.from(destArray);
    
    let [removed] = sourceClone.splice(source.index, 1);

    destClone.splice(destination.index, 0, removed);
    
    result[source.droppableId]      = sourceClone;
    result[destination.droppableId] = destClone;

    return result;
}

// Determines if given component/permission_type combo exists in permissionList
export function checkPermission(permissionList, input_component_name, input_permission_type) {

    let permission_type = input_permission_type;
    let component_name  = input_component_name;

    if(input_permission_type !== "navbar") {
        // console.log('checkPermission', input_component_name, input_permission_type);
    }

    permission_type = standardizePermissionType(permission_type);

    if(typeof permissionList !== 'undefined') {
        if(permissionList.filter((permission_info) => {
            if(permission_info.ComponentName === component_name && permission_info.PermissionType === permission_type) {
                return true;
            } else {
                return false;
            }
        }).length > 0) {
            return true;
        }
    }

    return false;
}

// Convert permission_type to standardized type
export function standardizePermissionType(input_permission_type) {
    let permission_type = input_permission_type;
    
    if (permission_type === "add" || permission_type === "addNew") {
        permission_type = "create";
    }

    if (permission_type === "list" || permission_type === "detail") {
        permission_type = "read";
    }

    if (permission_type === "save" || permission_type === "edit" || permission_type === "deactivate" || permission_type === "activate") {
        permission_type = "update";
    }

    if (permission_type === "remove") {
        permission_type = "delete";
    }

    return permission_type;
}

export function capitalizeString(input_string) {
    return input_string.charAt(0).toUpperCase() + input_string.slice(1)
}


// WEBPACK FOOTER //
// src/main/components/helpers/functions.js